import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function BulletPoints({ settings, section, columns }) {
  let isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  
  return (
    <div className={`flex flex-col gap-8 lg:gap-11 w-full lg:w-96`}>
      <div className="lg:col-span-1">
        <div className={`mb-2 lg:mb-[6px] ${isMobile ? `${section.points_tagline_font_type_mobile}` : `${section.points_tagline_font_type}`}`}>
          {section.points_tagline}
        </div>
        <h2 className={`${isMobile ? section.points_title_font_type_mobile : section.points_title_font_type}`}>
          {section.points_title}
        </h2>
      </div>
      <div className="inline-flex flex-col gap-6">
        {columns.map((column, index) => (
          <div key={index} className="inline-flex gap-3">
            <div className="inline-flex items-center justify-center rounded-full min-w-6 w-6 h-6 bg-[#D6CFF8]">
              <div className="relative w-5 h-5 overflow-hidden icon-check text-[#1C1C1F] text-center text-[18px]">
              </div>
            </div>
            <div className={`${isMobile ? column.settings.highlight_description_font_type_mobile : column.settings.highlight_description_font_type}`}>
              <span className={`${isMobile ? column.settings.highlight_label_font_type_mobile : column.settings.highlight_label_font_type}`}>{column.settings.highlight_label}</span>{' '}
              <span>{column.settings.highlight_description}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};